<template>
  <div class="success">
      <div class="center">
          <div class="successImg"></div>
          <div class="successText">{{tipsText}}</div>
      </div>
  </div>
</template>

<script>
export default {
    props:{
        tipsText:String,
        required:true,
    }
}
</script>

<style lang='less' scoped>
    .success{
        width: 100%;
        height: 46.5px;
        background-color: #FDAFAF;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 66;
        .center{
            width: 105px;
            height: 100%;
            margin: auto;
            .successImg{
                width: 24px;
                height: 100%;
                float: left;
                background-image: url('../assets/img/home/error.png');
                background-repeat: no-repeat;
                background-size: 24px 24px;
                background-position: center;
            }
            .successText{
                font-size: 16px;
                color: #FF6060;
                float: right;
                line-height: 46.5px;
            }
            
        }
    }
</style>